import { useEffect, useRef, useCallback } from "react"

type IntersectionObserverOptions = {
    root?: Element | null
    rootMargin?: string
    threshold?: number | number[]
  }
  
  export const useImageIntersectionObserver = (
    callback: (isIntersecting: boolean) => void,
    options?: IntersectionObserverOptions
  ) => {
    const targetRef = useRef<Element | null>(null)
    const observer = useRef<IntersectionObserver | null>(null)
  
    const handleIntersect = useCallback(
      (entries: IntersectionObserverEntry[]) => {
        entries.forEach((entry) => {
          callback(entry.isIntersecting)
        })
      },
      [callback]
    )
  
    useEffect(() => {
      const target = targetRef.current
      if (!target) return
  
      if (observer.current) {
        observer.current.disconnect()
      }
  
      observer.current = new IntersectionObserver(handleIntersect, options)
      observer.current.observe(target)
  
      return () => {
        if (observer.current) {
          observer.current.disconnect()
          observer.current = null
        }
      }
    }, [options, handleIntersect])
  
    return targetRef
  }